import { useTranslation } from 'react-i18next';
import { LocaleLink } from '@/components/LocaleLink';
import { CalculatorLink, MethodologyLink } from './LandingActions';
import { PublicFooter } from '@/components/visual/PublicFooter';

export const HowItWorks = () => {
  const { t } = useTranslation();
  return <section id="how-it-works" tabIndex={-1} className="lp-section lp-how" data-testid="landing-how-it-works" aria-labelledby="landing-how-title">
    <div className="lp-container">
      <h2 id="landing-how-title" data-testid="landing-how-title">{t('homepage.how.heading')}</h2>
      <ol className="lp-steps" x-excluded="true">
        {['one', 'two', 'three'].map((key, index) => <li key={key} data-testid={`landing-step-${key}`}>
          <span className="lp-step-number" aria-hidden="true">0{index + 1}</span>
          <div><h3>{t(`homepage.how.${key}.title`)}</h3><p>{t(`homepage.how.${key}.body`)}</p></div>
        </li>)}
      </ol>
      <CalculatorLink placement="how_it_works" />
    </div>
  </section>;
};

export const MethodologySection = () => {
  const { t } = useTranslation();
  return <section className="lp-section lp-methodology" data-testid="landing-methodology" aria-labelledby="landing-methodology-title">
    <div className="lp-container lp-methodology-layout">
      <h2 id="landing-methodology-title" data-testid="landing-methodology-title">{t('homepage.methodology.heading')}</h2>
      <div><p data-testid="landing-methodology-description">{t('homepage.methodology.body')}</p>
        <p className="lp-small-note" data-testid="landing-methodology-limit">{t('homepage.methodology.limit')}</p>
        <MethodologyLink placement="credibility" /></div>
    </div>
  </section>;
};

export const FinalCta = () => {
  const { t } = useTranslation();
  return <section className="lp-section lp-final" data-testid="landing-final" aria-labelledby="landing-final-title">
    <div className="lp-container">
      <h2 id="landing-final-title" data-testid="landing-final-title">{t('homepage.final.heading')}</h2>
      <CalculatorLink placement="final" />
      <p data-testid="landing-final-note">{t('homepage.final.note')}</p>
    </div>
  </section>;
};

export const LandingFooter = () => {
  const { t } = useTranslation();
  return <PublicFooter testPrefix="landing-footer" links={<>
          <CalculatorLink placement="footer" textOnly>{t('homepage.primaryAction')}</CalculatorLink>
          <MethodologyLink placement="footer" />
          <LocaleLink to="/blog" data-testid="landing-footer-blog">{t('footer.blog')}</LocaleLink>
          <LocaleLink to="/auth" data-testid="landing-footer-signin">{t('nav.signIn')}</LocaleLink>
  </>} />;
};